import { useMemo, useState } from 'react'
import { usePageActions } from '../AppLayout'
import { ErrorBox, Loading } from '../components/common/Feedback'
import { Umschalter } from '../components/common/Umschalter'
import { UebersichtAnsicht } from '../components/uebersicht/UebersichtAnsicht'
import { useUebersicht } from '../hooks/useUebersicht'
import { SCHWELLEN } from '../hooks/uebersichtRegeln'

type Sicht = 'alle' | 'neu'

const SICHTEN: { wert: Sicht; text: string }[] = [
  { wert: 'alle', text: 'Alle' },
  { wert: 'neu', text: 'Nur Neues' },
]

/**
 * Die Startseite: was sich seit gestern Abend gerührt hat, nach Vorzeichen.
 *
 * KEIN EIGENES RECHT: Die Seite holt aus den Listen, die es gibt, und zeigt,
 * was die Rechte hergeben. Wer nur Meldungen lesen darf, sieht nur
 * Meldungen — und keine Sperre.
 */
export function UebersichtPage() {
  const [sicht, setSicht] = useState<Sicht>('alle')
  const { laedt, fehler, daten } = useUebersicht(SCHWELLEN)

  usePageActions(useMemo(() => (
    <Umschalter optionen={SICHTEN} wert={sicht} onChange={setSicht}
                label="Alles oder nur Neues" />
  ), [sicht]))

  if (fehler) return <ErrorBox>{fehler}</ErrorBox>
  if (!daten) return <Loading>stellt die Übersicht zusammen …</Loading>

  return <UebersichtAnsicht daten={daten} nurNeu={sicht === 'neu'}
                            schwellen={SCHWELLEN} laedt={laedt} />
}
